import "../plugins/apollo.js";
import { useAuth } from "../plugins/banza/auth.js";
import "axios";
import "lodash-es";
import "pinia";
import "../store/index.js";
import "../plugins/i18n.js";
import "../plugins/banza/img.js";
import "maska";
import "vue";
import "vue-router";
import "../graphql/queries.js";
import "../graphql/subscriptions.js";
import "vuetify";
import "moment";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../constants/components/index.js";
/* empty css                                    */
import "vuetify/components/VDialog";
import "../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                                   */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                             */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../assets/8a32dc557a826bf0.png";
/* empty css                                */
import "../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                            */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../components/Auth/AppleAuthButton/AppleAuthButton.js";
import "../components/Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../components/Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../components/Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../components/Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                          */
import "vuetify/components/VGrid";
import "../components/Base/index.js";
import "vuex";
/* empty css                                   */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../icons/mdi/index.js";
/* empty css                                       */
import "vuetify/components/VBtnToggle";
import "../assets/6f5dc1ff0a697731.svg";
import "../assets/888bb8db73be3c15.svg";
/* empty css                                        */
import "vuetify/components/VInfiniteScroll";
/* empty css                                             */
/* empty css                                 */
import "vuetify/components/VChip";
/* empty css                                     */
import "../components/HtmlEditor/index.js";
import "../components/Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../components/Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                          */
/* empty css                                   */
import "../components/News/NewsModule/NewsModule.vue.js";
import "../components/News/NewsModule/NewsList.vue.js";
import "../graphql/news.js";
/* empty css                                   */
import "../components/Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                            */
import "vuetify/components/VWindow";
import "../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../graphql/system-settings.js";
/* empty css                                        */
/* empty css                                               */
import "vuetify/components/VHover";
import "../constants/NewsGroup.js";
/* empty css                                                */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                              */
import "vuetify/components/VBottomSheet";
import "../graphql/favorites.js";
import "../plugins/tracker/page-tracker.js";
/* empty css                                        */
import "../graphql/notifications.js";
/* empty css                                             */
import "../constants/CommunicationChannels.js";
/* empty css                                       */
import "vuetify/components/VColorPicker";
/* empty css                                                           */
import "vuetify/components/VTextarea";
/* empty css                                       */
import "vuetify/components/VTooltip";
/* empty css                                                        */
/* empty css                                     */
import "graphql-tag";
import "../graphql/lookups.js";
import "../graphql/entity.js";
/* empty css                                  */
import "vuetify/components";
/* empty css                                        */
/* empty css                                */
import "../graphql/system-events.js";
/* empty css                                                   */
/* empty css                                    */
/* empty css                                    */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                            */
/* empty css                                                          */
import "vuetify/components/VAlert";
/* empty css                                               */
import "vue-dndrop";
/* empty css                                                       */
/* empty css                                               */
import "vue-advanced-cropper";
import "../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                                   */
import "vuetify/components/VFileInput";
/* empty css                                       */
import "vuetify/components/VAvatar";
/* empty css                                             */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                         */
import "../graphql/public-articles.js";
/* empty css                                                      */
/* empty css                                          */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                             */
import "vuetify/components/VItemGroup";
/* empty css                                        */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                                   */
import "../graphql/quartz.js";
import "vue-i18n";
import "../graphql/integration-systems.js";
import "../constants/IntegrationSystemLogDirection.js";
/* empty css                                                                 */
/* empty css                                               */
import "../graphql/session-store.js";
import "../composables/useModalPage.js";
import "../icons/portal/index.js";
const routerMiddleware = (to, from) => {
  var _a, _b, _c, _d;
  const auth = useAuth();
  if (auth.isAuthenticated()) {
    if (to.path.includes("/signin")) {
      return navigateTo("/");
    }
  } else {
    if (!(((_a = to.meta) == null ? void 0 : _a.layout) === "public")) {
      return navigateTo("/signin");
    }
  }
  if (to.path !== to.path.toLowerCase()) {
    return navigateTo(to.path.toLowerCase());
  }
  if (auth.isAuthenticated() && (((_b = to.meta) == null ? void 0 : _b.admin) || ((_c = to.meta) == null ? void 0 : _c.protected))) {
    let hasPolicies = false;
    if ((_d = to.meta.policies) == null ? void 0 : _d.length) {
      hasPolicies = auth.hasOneOfPolicies(to.meta.policies);
      if (!hasPolicies) {
        return showError({ statusCode: 403 });
      }
    }
    if (!hasPolicies) {
      const roles = to.meta.roles;
      if (roles == null ? void 0 : roles.length) {
        if (!auth.hasOneOfRoles(roles)) {
          return showError({ statusCode: 403 });
        }
      } else if (!auth.isAdmin()) {
        return showError({ statusCode: 403 });
      }
    }
  }
};
export {
  routerMiddleware
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
